var _rect, _rect2, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconEdit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "none"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 2364,
    height: 1046,
    transform: "translate(-672 -362)",
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4_3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.8669 7.49771L16.5021 10.133L8.99671 17.6291L6.13794 18.1971L5.7934 17.8526L6.36143 14.9938L13.8669 7.49771ZM13.8669 4.86243L5.04845 13.6808C4.78771 13.9416 4.61078 14.2675 4.53629 14.6307L3.96826 17.4894C3.8472 18.104 4.03344 18.7279 4.48042 19.1749L4.82496 19.5194C5.17881 19.8733 5.65372 20.0688 6.14726 20.0688C6.26831 20.0688 6.38937 20.0595 6.51042 20.0316L9.36919 19.4636C9.73236 19.3891 10.0583 19.2121 10.319 18.9514L19.1374 10.133L13.8669 4.86243Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1894 3.54939L13.8765 4.86237L19.147 10.1329L20.46 8.81995C21.1863 8.09362 21.1863 6.911 20.46 6.18467L17.8154 3.54939C17.0891 2.82306 15.9065 2.82306 15.1801 3.54939H15.1894ZM17.8247 8.81995L15.1894 6.18467L16.5024 4.87168L19.1377 7.50697L17.8247 8.81995V8.81995Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4_3"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "none",
    transform: "translate(3 3)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEdit);
export default __webpack_public_path__ + "static/media/icon-edit.a9f3454580853dd99a7b8939b7b90285.svg";
export { ForwardRef as ReactComponent };